'use client';

import styles from './IconGrid.module.css';

// icons
import {
    Zap, Pattern_recognition, Typo_or_bug, Typing,
    Hybrid_search, Discovery, Scales, Filter,
    Sliders_vertical, Sort_descending, Nested_object, Flag,
    Update, Linear, Internet_browser, Analytics,
    Boost, Synonym, Search_or_ask, Observr,
    Mcp, Key, Terminal, User_privacy
} from "@indxsearch/pixl";
import FeatureIcon from '../components/FeatureIcon';

// The whole product in one list, in the order a reader meets it: the engine, then the server
// around it, then what the AI adds. Under Indx Server's console on the home page.
const features = [
  // The engine
  { icon: <Zap />, label: "Instant response time" },
  { icon: <Pattern_recognition />, label: "Pattern recognition" },
  { icon: <Typo_or_bug />, label: "Unmatched typo tolerance" },
  { icon: <Typing />, label: "Search as you type" },
  { icon: <Hybrid_search />, label: "Hybrid search" },
  { icon: <Discovery />, label: "Relevancy ranking" },
  { icon: <Scales />, label: "Field weights" },
  { icon: <Filter />, label: "Advanced filters" },
  { icon: <Sliders_vertical />, label: "Faceted navigation" },
  { icon: <Sort_descending />, label: "Result sorting" },
  { icon: <Nested_object />, label: "Nested JSON support" },
  { icon: <Flag />, label: "Supports all languages" },
  { icon: <Update />, label: "Real-time updates" },
  { icon: <Linear />, label: "Linear performance scaling" },
  // The server
  { icon: <Internet_browser />, label: "Admin console" },
  { icon: <Analytics />, label: "Search statistics" },
  { icon: <Boost />, label: "Scheduled boost rules" },
  { icon: <Synonym />, label: "Synonyms" },
  { icon: <Key />, label: "Team-scoped API keys" },
  { icon: <Mcp />, label: "MCP server" },
  { icon: <Terminal />, label: "Terminal monitor" },
  { icon: <User_privacy />, label: "Self-hosted, GDPR friendly" },
  // The AI
  { icon: <Search_or_ask />, label: "Search, or ask" },
  { icon: <Observr />, label: "Observr agent" },
];

export default function IconGrid({ className = '' }: { className?: string }) {
    return (
      <div className={`${styles.wrapper} ${className}`}>
        <div className={styles.inside}>
          {features.map(({ icon, label }) => (
            <FeatureIcon key={label} icon={icon} label={label} />
          ))}
        </div>
      </div>
    );
}
